// extracted by mini-css-extract-plugin
module.exports = {"payments-form":"styles__payments-form___2uG6v","error-alert":"styles__error-alert___abflL","button":"styles__button___1LkwG"};